import script from "./ViewProfessionalDevelopmentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewProfessionalDevelopmentPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewProfessionalDevelopmentPage.vue?vue&type=style&index=0&id=a62c57d8&scoped=true&lang=css"
import "./ViewProfessionalDevelopmentPage.vue?vue&type=style&index=1&id=a62c57d8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a62c57d8"]])

export default __exports__